import { ArrowIcon, Spinner, Typography } from '@weareopenr/component-library';
import { useState } from 'react';
import classnames from 'classnames/bind';
import SelectableList, { SelectableListOption } from 'src/components/SelectableList/SelectableList';
import styles from './SelectedItemsCollapsible.module.scss';

const cx = classnames.bind(styles);

interface SelectedItemsCollapsibleProps {
  count: number;
  options: SelectableListOption[];
  selectedOptionsIds: string[];
  onChange: (selectedIds: string[]) => void;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export const SelectedItemsCollapsible = ({
  count,
  options,
  selectedOptionsIds,
  onChange,
  isDisabled,
  isLoading,
}: SelectedItemsCollapsibleProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const disabled = isDisabled || count === 0;

  return (
    <div className={cx('selected-collapsible', { disabled })}>
      <button
        className={cx('selected-header')}
        onClick={() => setIsExpanded(!isExpanded)}
        type="button"
        aria-expanded={isExpanded ? 'true' : 'false'}
        aria-label="Currently selected items"
        disabled={disabled}
      >
        {isLoading ? (
          <Spinner size="small" />
        ) : (
          <Typography className={cx('count-text')} size="medium" weight="semi-bold">
            Currently Selected ({count})
          </Typography>
        )}
        <div className={cx('arrow-button')}>
          <ArrowIcon className={cx('arrow', { 'arrow-down': !isExpanded })} />
        </div>
      </button>
      {isExpanded && count > 0 && (
        <SelectableList
          options={options}
          selectedOptions={selectedOptionsIds}
          onChange={onChange}
          disabled={isDisabled}
        />
      )}
    </div>
  );
};
